import Vue from "vue";
import VueRouter from "vue-router";
import login from "@/views/login";
import home from "@/views/home/home";
import orders from "@/views/home/orders/index.vue";
import agent from "@/views/home/agent/index.vue";
import {getLocalStorage} from "@/utils/localStorage.js";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        redirect: "/home",
    },
    {
        path: "/login",
        name: "login",
        component: login,
        meta: {
            title: "Login",
        },
    },
    {
        path: "/home",
        name: "home",
        component: home,
        redirect: "/home/orders/index",
        children: [
            {
                path: "/home/orders/index",
                name: "orders",
                component: orders,
                meta: {
                    title: "ALM",
                },
            },
            {
                path: "/home/agent/index",
                name: "agent",
                component: agent,
                meta: {
                    title: "ALM",
                },
            },
        ],
    },
];

const router = new VueRouter({
    mode: "hash",
    routes,
});

router.afterEach((to, from) => {
    document.title = to.meta.title || "";
});

export default router;
